import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Document } from '../model/document';
import { PageDocumentSelectedDTO } from '../model/page-document-selected-dto';
import { AssocierDocumentAuProduit } from '../model/associer-document-au-produit';

@Injectable({
    providedIn: 'root'
  })
  export class DocumentService{
  

    constructor(private _restClientService : RestClientService) { }
    
    
    findSelectedDocumentPageable(filter, produitId, page, size, sortColomun,descending){
      return this._restClientService.load<PageDocumentSelectedDTO>('document/find-selected-document-pageable?produitid='+produitId+
      '&filter='+filter+
      '&page='+page+
      '&size='+size+
      '&sortColomun='+sortColomun+
      '&descending='+descending
      );
    }
    
    fichierAFournirNotUploadedProductProgram(requestId) {
      return this._restClientService.load<Document[]>('document/fichier-a-fournir-not-uploaded-product-program?requestid='+requestId);
    }

    fichierAFournirNotUploadedParticulier(requestId) {
      return this._restClientService.load<Document[]>('document/fichier-a-fournir-not-uploaded-particulier?requestid='+requestId);
    }

    fichierAFournirNotUploadedCorporate(requestId) {
      return this._restClientService.load<Document[]>('document/fichier-a-fournir-not-uploaded-corporate?requestid='+requestId);
    }

    fichierAFournirNotUploadedProfessionnel(requestId) {
      return this._restClientService.load<Document[]>('document/fichier-a-fournir-not-uploaded-professionnel?requestid='+requestId);
    }

    add(document: Document) {
      return this._restClientService.save<Document>('document/add', document);
    }
    
    findById(documentId) {
      return this._restClientService.load<Document>('document/find-by-id/'+documentId);
    }
    
    update(document: Document) {
      return  this._restClientService.put<Document>(`document/update`, document);
    }
      
    associer(associerDocumentAuProduit: AssocierDocumentAuProduit) {
      return this._restClientService.save<Document>('document/associer-document-produit', associerDocumentAuProduit);
    }
  


}      

    